import {
    apiTokenService,
    AuthContext,
    CONTEXT_TYPE,
    getTemplate
} from "@harvestr-api/common";
import { logger } from "@harvestr-api/utils";
import base64url from "base64url";
import { Request, Response } from "express";
import { OAuth2 } from "oauth";
import * as request from "request";
import * as url from "url";
import { githubApiService } from "./github-api.service";

// Github redirects the user here after authentication
const github_loginCallback = `${
    process.env.H_API_URL || ""
}/authorize/github/callback`;
const github_key = process.env.GITHUB_OAUTH_CLIENT_ID;
const github_secret = process.env.GITHUB_OAUTH_CLIENT_SECRET;
const github_oauth_scope =
    "user public_repo repo repo_deployment repo:status read:repo_hook write:repo_hook read:org read:public_key read:gpg_key";
const _getGithubConsumer = async (github_subdomain: string) => {
    const github_authorizeURL = "login/oauth/authorize";
    const github_accessURL = "login/oauth/access_token";
    const github_baseSite = `https://github.com/`;
    const consumer = new OAuth2(
        github_key,
        github_secret,
        github_baseSite,
        github_authorizeURL,
        github_accessURL,
        null
    );
    return consumer;
};

export const githubOauthService = {
    async handleGithubOauth(req: Request, res: Response) {
        try {
            logger.info(github_key);
            logger.info(github_loginCallback);
            const subdomain = req.query.subdomain as string;
            const project_id = req.query.id;
            logger.info("subdomain :", subdomain);
            const github_consumer = await _getGithubConsumer(subdomain);
            const github_authorize_full_URL = github_consumer.getAuthorizeUrl({
                response_type: "code",
                scope: github_oauth_scope,
                redirect_uri: github_loginCallback,
                state: base64url(
                    JSON.stringify({
                        project_id,
                        subdomain
                    })
                )
            });
            logger.info(github_authorize_full_URL);
            res.redirect(github_authorize_full_URL);
        } catch (error) {
            logger.error(error);
            res.status(400).send(error);
        }
    },

    async handleGithubOauthResponse(req: Request, res: Response) {
        try {
            const state = req.query.state as string;
            const query: any = url.parse(req.url, true).query || {};
            const code = query.code;
            const { project_id, subdomain } = JSON.parse(
                base64url.decode(state)
            );
            console.log(project_id, subdomain);
            if (!project_id) {
                throw new Error("No project id found");
            }
            const context: AuthContext = {
                type: "INTEGRATION_GITHUB" as CONTEXT_TYPE,
                project_id
            };
            request.post(
                {
                    url: "https://github.com/login/oauth/access_token",
                    form: {
                        client_id: github_key,
                        client_secret: github_secret,
                        code,
                        grant_type: "authorization_code",
                        redirect_uri: github_loginCallback
                    }
                },
                async (error, httpResponse, string_body) => {
                    let token = "";
                    try {
                        if (error) {
                            throw new Error(error.data);
                        }
                        const body = JSON.parse(
                            '{"' +
                                string_body
                                    .replace(/&/g, '","')
                                    .replace(/=/g, '":"') +
                                '"}',
                            function (key, value) {
                                return key === ""
                                    ? value
                                    : decodeURIComponent(value);
                            }
                        );

                        const hasUserRightAccessLevel = await githubApiService.hasUserRequiredPermissions(
                            {},
                            context,
                            body.access_token
                        );

                        if (!hasUserRightAccessLevel) {
                            token = body.access_token;
                            throw new Error("not_enough_permissions");
                        }

                        await apiTokenService.createApiToken(
                            {
                                source: "GITHUB",
                                token: body.access_token,
                                subdomain: subdomain || undefined
                            },
                            context
                        );
                        res.status(200).send(
                            "<h3>Success! Redirecting...</h3><h4>You can close this window.</h4>"
                        );
                        return;
                    } catch (err) {
                        if (err.message === "not_enough_permissions") {
                            const userOrgs = await githubApiService.getUserOrgs(
                                context,
                                token
                            );

                            res.status(400).send(
                                getTemplate("github_not_enough_permissions", {
                                    orgs: userOrgs
                                })
                            );
                        } else {
                            logger.error(err);
                            throw new Error("error getting access token");
                        }
                    }
                }
            );
        } catch (error) {
            logger.error(error);
            res.status(400).send(`<h3>Error: </h3>${error}`);
        }
    }
};

// var http = require('http');
// var qs = require('querystring');
// // var OAuth = require('oauth'), OAuth2 = OAuth.OAuth2;
// var OAuth2 = require('../lib/oauth2.js').OAuth2;

// var clientID = '';
// var clientSecret = '';
// var oauth2 = new OAuth2(clientID,
//                         clientSecret,
//                         'https://github.com/',
//                         'login/oauth/authorize',
//                         'login/oauth/access_token',
//                         null); /** Custom headers */

// http.createServer(function (req, res) {
//     var p = req.url.split('/');
//     pLen = p.length;

//     /**
//      * Authorised url as per github docs:
//      * https://developer.github.com/v3/oauth/#redirect-users-to-request-github-access
//      *
//      * getAuthorizedUrl: https://github.com/ciaranj/node-oauth/blob/master/lib/oauth2.js#L148
//      * Adding params to authorize url with fields as mentioned in github docs
//      *
//      */
//     var authURL = oauth2.getAuthorizeUrl({
//         redirect_uri: 'http://localhost:8080/code',
//         scope: ['repo', 'user'],
//         state: 'some random string to protect against cross-site request forgery attacks'
//     });

//     /**
//      * Creating an anchor with authURL as href and sending as response
//      */
//     var body = '<a href="' + authURL + '"> Get Code </a>';
//     if (pLen === 2 && p[1] === '') {
//         res.writeHead(200, {
//             'Content-Length': body.length,
//             'Content-Type': 'text/html' });
//         res.end(body);
//     } else if (pLen === 2 && p[1].indexOf('code') === 0) {

//         /** Github sends auth code so that access_token can be obtained */
//         var qsObj = {};

//         /** To obtain and parse code='...' from code?code='...' */
//         qsObj = qs.parse(p[1].split('?')[1]);

//         /** Obtaining access_token */
//         oauth2.getOAuthAccessToken(
//             qsObj.code,
//             {'redirect_uri': 'http://localhost:8080/code/'},
//             function (e, access_token, refresh_token, results){
//                 if (e) {
//                     console.log(e);
//                     res.end(e);
//                 } else if (results.error) {
//                     console.log(results);
//                     res.end(JSON.stringify(results));
//                 }
//                 else {
//                     console.log('Obtained access_token: ', access_token);
//                     res.end( access_token);
//                 }
//         });

//     } else {
//         // Unhandled url
//     }
